export const cloudNativeEnabledSelector = (state) => {
    const license = state.license.data;
    if (!license) return false;
  
    const isNotExpired = new Date(license.expiry_date) > new Date();
    return license.permissions?.cloud_native && isNotExpired;
  };
  
  export const crowdstrikeEnabledSelector = (state) => {
    const license = state.license.data;
    if (!license) return false;
  
    const isNotExpired = new Date(license.expiry_date) > new Date();
    return license.permissions?.crowdstrike && isNotExpired;
  };
